import '../stylesheets/app.entry.scss'

import 'intersection-observer'

import 'service/sentry'
import 'utils/lazyload'
import 'utils/announcements'
import 'utils/convertToSVG'
